import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import {
  KcVinValidationViewData
} from '../../../interfaces/kc-data.interface'

import { delay } from 'rxjs'
import { KcDataService } from '../../../kc-data.service'
@Component({
  selector: 'customer-portal-revolution-vin-validation',
  templateUrl: './revolution-vin-validation.component.html'
})
export class RevolutionVinValidationComponent implements OnInit {
  constructor (
    private readonly kcDataService: KcDataService,
    public transifexService: TransifexService,
    public remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {}

  @ViewChild('vinValidationForm', { static: true })
  private readonly formRef: ElementRef

  public form = new FormGroup({
    vin: new FormControl<string | null>(null, [
      Validators.minLength(17),
      Validators.maxLength(17),
      Validators.pattern('^[a-zA-Z0-9]+$')
    ])
  })

  public viewData: KcVinValidationViewData
  public submitting: boolean
  public VIN: string | null

  validationError = false
  notValid = false
  skipVinValidation = false
  submittingButton: string

  ngOnInit (): void {
    this.viewData = this.kcDataService.getViewData() as KcVinValidationViewData
    this.onFormReady()
  }

  private onFormReady (): void {
    if (
      this.viewData.formData.vin != null &&
      this.viewData.formData.vin.length > 0
    ) {
      this.form.controls.vin.valueChanges.pipe(delay(1)).subscribe(() => {
        if (this.viewData.formData.vin !== this.form.get('vin').value) {
          this.notValid = false
        } else {
          this.notValid = true
        }
      })

      this.form.patchValue({
        vin: this.viewData.formData.vin
      })
      this.form.controls.vin.markAsDirty()
      this.form.controls.vin.markAsTouched()
      this.validationError = true
    }

    this.form.updateValueAndValidity()
  }

  public submit (): void {
    this.submitting = true

    setTimeout(() => {
      // submit form
      const formElement = this.formRef.nativeElement as HTMLFormElement
      formElement.submit()
    })
  }
}
